import isEmpty from '@pkg/utils/objects/isEmpty';

const ASSIGNED = Object.freeze({
  isManager: false,
  roles: {},
});

/**
 * @param {Object} me
 * @param {Object} snapshot
 * @return {Object}
 */
export default function getAssigned(me, snapshot) {
  if (!me?.person?.uuid || isEmpty(snapshot?.entities?.roles)) {
    return ASSIGNED;
  }

  const assigned = structuredClone(ASSIGNED);
  for (const id in snapshot.entities.roles) {
    const role = snapshot.entities.roles[id];
    if (role.person_uuid === me.person.uuid) {
      assigned.isManager = assigned.isManager || role.is_manager;
      assigned.roles[id] = role;
    }
  }

  return assigned;
}
